import { useRouter } from 'next/router';
import { useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import Button from '@base/Button/Button';
import { mediaQuery, Spacings } from '@styles/index';
import { setModalState } from '@actions/quizTaking';
import { getQuizDetails } from '@selectors/quizTaking';
import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import pushRoute from '@utils/pushRoute';
import { SOLUTION_VIEWED } from '@constants/segment';
import { MODAL_TYPES, SOLUTION_TYPE } from '../../../constants';
import useQuizSegmentAnalytics from '../../../Common/useQuizSegmentAnalytics';
import useQuizStatus from '../../Common/useQuizStatus';

const Wrapper = styled.div`
  display: flex;
  gap: ${Spacings.SPACING_5B};
  margin-top: ${Spacings.SPACING_12B};
  ${mediaQuery.uptoMobile} {
    flex-flow: column;
  }
`;

const StyledButton = styled(Button)`
  ${mediaQuery.uptoMobile} {
    width: 100%;
  }
`;

const SubjectiveActions = () => {
  const dispatch = useDispatch();
  const { query } = useRouter();
  const { quizSlug, quizUID } = query;

  const quizDetails = useSelectorWithShallowEqual(getQuizDetails(quizUID));

  const segmentAnalytics = useQuizSegmentAnalytics();
  const { isLive, isSubjectiveAnswerUploadPending } = useQuizStatus();

  const handleOnSubmitClick = () => {
    dispatch(
      setModalState({
        type: MODAL_TYPES.QUIZ_UPLOAD_SUBJECTIVE_ANSWER,
        data: {}
      })
    );
  };

  const handleOnSkip = () => {
    dispatch(
      setModalState({
        type: MODAL_TYPES.QUIZ_REJECT_UPLOAD_COMFIRMATION,
        data: {}
      })
    );
  };

  const handleViewSolutionClicked = () => {
    segmentAnalytics(SOLUTION_VIEWED, {});
    const sessionUID = quizDetails.latest_session.uid;

    pushRoute(
      {
        pathname: '/quiz/[quizSlug]/[quizUID]/solutions/[sessionUID]',
        query: {
          quizSlug,
          quizUID,
          sessionUID,
          type: SOLUTION_TYPE.MODAL
        }
      },
      undefined,
      { shallow: true }
    );
  };

  if (isSubjectiveAnswerUploadPending) {
    return (
      <Wrapper>
        <StyledButton label="Submit answers" onClick={handleOnSubmitClick} />
        <StyledButton
          label="Skip submission"
          variant="hollow"
          color="black"
          onClick={handleOnSkip}
        />
      </Wrapper>
    );
  }

  if (isLive) {
    return null;
  }

  return (
    <Wrapper>
      <Button label="Model solutions" onClick={handleViewSolutionClicked} />
    </Wrapper>
  );
};

export default SubjectiveActions;
